import React, { FC } from 'react';

import CustomSkeleton from '~components/atoms/Skeleton';
import * as Styles from './_table.module.scss';

type TRow =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | any[]
    | {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        cells: any[];
        className?: string;
    };

type TableProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    header: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: TRow[];
    isLoading?: boolean;
    error?: string;
    containerClassName?: string;
    tableClassName?: string;
};

const Table: FC<TableProps> = ({
    header,
    body,
    isLoading,
    error,
    containerClassName,
    tableClassName,
}) => {
    const renderHeaderRow = () => {
        if (isLoading) {
            return (
                <th className={Styles['is-loading']}>
                    <CustomSkeleton height={40} />
                </th>
            );
        }

        return header.map(item => {
            return (
                <th key={item}>
                    {item}
                </th>
            );
        });
    };

    const renderBodyRow = () => {
        if (isLoading) {
            return (
                <tr>
                    <td className={Styles['is-loading']}>
                        <CustomSkeleton height={40} count={5} />
                    </td>
                </tr>
            );
        }

        if (error) return <tr className={Styles['no-data-found-text']}><td>{error}</td></tr>;

        if (!body.length) return <tr className={Styles['no-data-found-text']}><td>No data found</td></tr>;

        return body.map((row, index) => {
            const isObjectRow = !Array.isArray(row);

            const cells = isObjectRow ? row.cells : row;
            const customClass = isObjectRow ? row.className : '';

            return (
                <tr
                    key={index}
                    className={`${Styles['table-body-row']} ${customClass || ''}`}
                >
                    {cells.map((cell, idx) => (
                        <td key={idx}>
                            {cell}
                        </td>
                    ))}
                </tr>
            );
        });
    };

    return (
        <div className={`${Styles.container} ${containerClassName}`}>
            <table className={`${Styles.table} ${tableClassName}`}>
                <thead>
                    <tr>
                        {renderHeaderRow()}
                    </tr>
                </thead>

                <tbody>
                    {renderBodyRow()}
                </tbody>
            </table>
        </div>
    );
};

export default Table;
